import { render } from "./TotalCustomer.vue?vue&type=template&id=769ded6a&ts=true"
import script from "./TotalCustomer.vue?vue&type=script&lang=ts"
export * from "./TotalCustomer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__